import React from 'react';
import { Container, Row, Col, Image, Pagination, Form, Button } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { RiArrowRightSLine } from 'react-icons/ri';
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import { BsArrowDownShort } from "react-icons/bs";
import { BiSearch } from "react-icons/bi";
import Blc_button from '../Blc_Common/Blc_Button/Blc_button';
import Blc_BlogSearch from '../Blc_Blog_Search/Blc_BlogSearch';
import './blc_blog.css';

//No Hero Section will be here.

const blogsPerRow = 6;

const Blc_Blog_copy = (props) => {
  const searchBox = document.getElementById("searchBox");
  const [next, setNext] = useState(blogsPerRow);
  const [searchResult, setSearchResult] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchShow, setSearchShow] = useState(false);
  const handleSearchClose = () => setSearchShow(false);
  const handleSearchShow = () => setSearchShow(true);

  function formatQuery(str) {
    return str.split(' ').join('-');
  }

  const handleLoadMore = () => {
    setNext(next + blogsPerRow);
  };

  /*  const items = props.valHighlights.blc_news;
   const latestItem = items[items.length - 1];
   const restItems = items.slice(0, items.length - 1); */

  // items in reverse order: latest at first
  const items = props.valHighlights.blc_news.slice().reverse();
  const latestItem = items[0];
  const restItems = items.slice(1, items.length);




  return (
    <section id='blc-blog'>
      <div style={{ backgroundColor: 'white' }}>
        <Container>
          {/* <h2 className='blcPress'>BLC Press</h2> */}
          <div className="blcpress-title-container">

            <h2 className="text-start titles mb-1">
              <span className='me-2 titles-black'>BLC</span>
              <span>Press</span>
            </h2>
            <button onClick={handleSearchShow}
              className="searchBtn">
              <BiSearch />
            </button>
          </div>
          {/* <hr style={{ margin: '0', padding: '0' }} /> */}
        </Container>
        <Container className="mt-5">

          {/* <Container> */}
          {latestItem && <div >
            <Row className="gap-4 mb-5">
              <Col xs={12} sm={12} md={6} lg={6} >
                <Image src={latestItem.blc_news_img.data[0].attributes.url} className='hero-news-thumbnail' rounded />
              </Col>
              <Col xs={12} sm={12} md={5} lg={5} >
                <Link to={`/blchighlights?newsHeading=${formatQuery(latestItem.blc_news_name)}&newsId=${latestItem.id}`} className='read-hover'>
                  <p className='hero-blog-newest'>The newest</p>
                  <h4 className='hero-news-title'> {latestItem.blc_news_name} </h4>
                  <p className="hero-news-caption my-3">
                    {latestItem.blc_news}
                  </p>
                  <p className='hero-news-date'>{latestItem.blc_news_date}</p>
                </Link>
              </Col>
            </Row>
          </div>
          }
          <Row className="g-5 mb-4">
            {restItems.slice(0, next)?.map((data, index) => {
              return (
                <Col xs={12} sm={12} md={4} lg={4} style={{ position: 'relative' }}>
                  <Image src={data.blc_news_img.data[0].attributes.url} className='old-news-thumbnail' rounded />

                  <h4 className='old-news-title'> {data.blc_news_name} </h4>
                  <p className="old-news-caption  my-3">
                    {data.blc_news}
                  </p>
                  <p className='old-news-date'>{data.blc_news_date}</p>


                  <Link to={`/blchighlights?newsHeading=${formatQuery(data.blc_news_name)}&newsId=${data.id}`} >
                    <button className="readMore-btn">
                      Read more <RiArrowRightSLine />
                    </button>
                  </Link>

                  {/* <Blc_button title={'Read more'} /> */}
                </Col>
              )
            })
            }
          </Row>

          {next < items?.length && (
            <div className='load-more-btn-contanier'>
              <button
                className="load-more-btn"
                onClick={handleLoadMore}
              >
                <span>LOAD MORE BLOGS</span> <BsArrowDownShort size={22} />
              </button>
            </div>
          )}
          {/* <Row className="g-5 mb-4">
            {restItems.map((data) => (
              <Col xs={12} sm={12} md={4} lg={4} style={{ position: 'relative' }}>
                <Image src={data.blc_news_img.data[0].attributes.url} className='old-news-thumbnail' rounded />

                <h4 className='old-news-title'> {data.blc_news_name} </h4>
                <p className="old-news-caption  my-3">
                  {data.blc_news}
                </p>
                <p className='old-news-date'>{data.blc_news_date}</p>

                <Link to={`/blchighlights?newsHeading=${formatQuery(data.blc_news_name)}&newsId=${data.id}`} className='read-hover' style={{ position: 'absolute', bottom: '0' }}>
                  Read more <RiArrowRightSLine />
                </Link>
              </Col>
            ))
            }
          </Row> */}
          {/* </Container> */}

          <Blc_BlogSearch
            show={searchShow}
            items={items}
            handleClose={handleSearchClose}
          // searchResult={searchResult}
          // setSearchResult={setSearchResult}
          // searchText={searchText}
          // handleOnChange={handleOnChange}

          />
        </Container>

      </div>
    </section>
  );
};

export default Blc_Blog_copy